import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { toast } from "sonner";
import { useCurrency } from "@/context/CurrencyContext";
import { I18nLanguagesCard } from "./I18nLanguagesCard";
import { I18nCurrenciesCard } from "./I18nCurrenciesCard";

// Phase 81 — langues & devises administrables : un seul chargement de /admin/i18n/config partagé par les deux cartes
export function I18nConfigCards() {
  const { reload } = useCurrency();
  const [config, setConfig] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/i18n/config"); setConfig(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  // Exécute une mutation puis rafraîchit la config admin ET le contexte public (sélecteurs du site)
  const mutate = useCallback(async (fn, okMsg) => {
    setBusy(true);
    try { await fn(); if (okMsg) toast.success(okMsg); await load(); await reload(); return true; }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); return false; }
    finally { setBusy(false); }
  }, [load, reload]);

  if (!config) return <div className="p-5 bg-white border border-[#DEE2E6] text-xs text-[#868E96]" data-testid="i18n-config-loading">Chargement des langues et devises…</div>;
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="i18n-config-cards">
      <I18nLanguagesCard config={config} mutate={mutate} busy={busy} />
      <I18nCurrenciesCard config={config} mutate={mutate} busy={busy} />
    </div>
  );
}
